<template>
  <div class="rgFsT" >
    <img class="mx-auto d-block" alt="idealive" src="@/assets/logo-idealive.png">
    <b-form  @submit.prevent="login" v-if="show">
      <b-form-group
        id="input-group-1"
        label="Email address:"
        label-for="input-1"
        description="We'll never share your email with anyone else."
      >
        <b-form-input
          id="input-1"
          v-model="email"
          type="email"
          required
          autofocus
          placeholder="Enter email"
        ></b-form-input>
      </b-form-group>

      <b-form-group id="input-group-2" label="Password:" label-for="input-2">
        <b-form-input
          id="input-2"
          v-model="password"
           type="password"
          required
          placeholder="Enter password"
        ></b-form-input>
      </b-form-group>
      <b-button type="submit" variant="outline-primary">Submit</b-button>
      <b-button type="button" v-on:click="onReset" variant="outline-danger">Reset</b-button>

      <p> {{ error }}</p>

      Si todavia no tiene una cuenta. Póngase en contacto con el administrador
      de su empresa o con <a href="mailto:carles.labrana@idealiveconsulting.com">idealive Consulting</a>

    </b-form>
  </div>
</template>

<script>
export default {
  data () {
    return {
      email: '',
      password: '',
      show: true,
      error: null
    }
  },
  methods: {
    onSubmit (evt) {
      alert('HELLO')
      // evt.preventDefault()
      // alert(JSON.stringify(this.form))
    },
    onReset (evt) {
      // evt.preventDefault()
      // Reset our form values
      this.email = ''
      this.password = ''
      // Trick to reset/clear native browser form validation state
      this.show = false
      this.$nextTick(() => {
        this.show = true
      })
    },
    login () {
      this.$store
        .dispatch('login', {
          email: this.email,
          password: this.password
        })
        .then(() => {
          this.$router.push({ name: 'Home' })
        })
        .catch(error => {
          console.log('ERROR: ' + error)
          // this.error = err.response.data
        })
    }
  }
}
</script>

<style scoped>

.rgFsT {
    color: #262626;
    color: rgba(var(--i1d,38,38,38),1);
    flex-grow: 1;
    justify-content: center;
    margin-top: 12px;
    max-width: 350px;
    width: 100%;
    margin: 40px auto;
}

 p {
    color: red;
  }

</style>
